import "./QualitiesDetails.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import Popup from "../../Components/Popup/Popup";
import Button from "../../Components/Button/Button";

import { STORE_CONFIG } from "../../Store/ConfigStore";
import {
  ROUTE_PROCESSED_QUALITIES,
  ROUTE_RAW_QUALITIES,
  ROUTE_QUALITIES_DETAILS,
} from "../../routes";
import { STORE_QUALITIES } from "../../Store/QualitiesStore";
import { STORE_AUTH } from "../../Store/AuthStore";

import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);

import XLSX from "xlsx";

import {
  formatDate,
  formatDateOnly,
  fixFloat,
  formatNumber,
} from "../../utility";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";

@inject((stores) => ({
  store: stores.store.get(STORE_QUALITIES),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class QualitiesDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      itemselector: false,
      addressselector: null,
      saving: false,
    };

    props.store.resetQualities();
    this.getQualities();
  }

  componentDidMount() {
    const { route, store } = this.props;
    if (route.params.hasOwnProperty("editedId")) {
      store.setEditedId(route.params.editedId);
      this.getQualities();
    }
  }

  getQualities = () => {
    const { store, socket } = this.props;
    if (store.selectedpallets) {
      const _this = this;
      socket.emitWithToken(
        "GetQualitiesDetails",
        { Pallets: store.selectedpallets },
        function (err, data) {
          if (err) {
            console.error(err);
          } else if (data) {
            console.log(data);
            if (data.Error) {
              _this.setState({ popup: "error", popupText: data.Error });
            } else {
              store.setQualities(data);
            }
          }
        }
      );
    }
  };

  showPopup = (text) => {
    this.setState({ popup: "result", popupText: text });
  };

  save = () => {
    const { store, socket, authStore } = this.props;
    const qualities = store.qualities;

    const data = {
      Type: store.type,
      User: authStore.user.Id,
      Pallets: store.selectedpallets,
      Quality: {},
      Sealnum:
        store.type === "raw" && qualities.Quality.WeighBill !== "error"
          ? qualities.WeighBill
          : null,
    };

    console.log(qualities);
    let error = false;
    store.qualitytypes.forEach((qualitytype) => {
      let value =
        qualities.Quality[qualitytype.name] === "error"
          ? null
          : qualities.Quality[qualitytype.name] || null;

      switch (qualitytype.type) {
        case "double":
          if (value) value = value.replace(",", ".");
          if (value && isNaN(value)) {
            this.showPopup("Nem megfelelő érték: " + qualitytype.text);
            error = true;
            return;
          }
          break;
        case "int":
          if (value && isNaN(value)) {
            this.showPopup("Nem megfelelő érték: " + qualitytype.text);
            error = true;
            return;
          }
          break;
      }

      data.Quality[qualitytype.name] = value;
    });

    if (error) return;

    const _this = this;
    this.setState({ saving: true });
    socket.emitWithToken("SetQualitiesDetails", data, function (err, data) {
      _this.setState({ saving: false });

      if (err) {
        console.error(err);
        _this.showPopup(err);
      } else {
        _this.showPopup("Sikeres mentés.");
      }
    });
  };

  back = () => {
    const { store, router } = this.props;
    store.resetQualities();
    store.setSelectedPallets([]);
    let route = "";
    switch (store.type) {
      case "processed":
        route = ROUTE_PROCESSED_QUALITIES;
        break;
      case "raw":
        route = ROUTE_RAW_QUALITIES;
        break;
    }
    router.navigate(route, { back: true });
  };

  handleDownload() {
    const { configStore, store } = this.props;
    const { mergeditems, task } = store;

    const merges = [];
    const data = [
      ["Rendelési azonosító", task.orderid],
      [],
      ["Cikkszám", "Cikknév", "Sarzs", "Szavidő", "Mennyiség", "Összekészítve"],
    ];
    let rowindex = 4;

    for (let i = 0; i < mergeditems.length; i++) {
      const mergeditem = mergeditems[i];
      const item = configStore.items[mergeditem.id] || {};

      console.log(mergeditem);

      data.push([
        item.Name,
        item.CodeManufacturer,
        mergeditem.sarzs || "",
        mergeditem.expiration || "",
        (mergeditem.quantity || 0) + " " + item.Unit,
        (mergeditem.picked || 0) + " " + item.Unit,
      ]);
    }

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "BL-" + task.id);

    XLSX.writeFile(wb, "BL-" + task.id + ".xlsx", {
      bookSST: true,
      compression: true,
    });
  }

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { qualities } = store;
    //console.log(qualities);
    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div className="table__top-backpanel">
              <Button className="task__editbutton" onClick={() => this.back()}>
                Vissza
              </Button>
              <div className="table__top-pagename">
                {(store.type === "raw" ? "Nyers" : "Feldolgozott") +
                  " áru minőség részletek"}
              </div>
            </div>

            <div className="table__top-backpanel">
              {
                <Button
                  className="task__editbutton"
                  disabled={this.state.saving}
                  onClick={() => this.save()}
                >
                  Mentés
                </Button>
              }
            </div>
          </div>
          <div className="masterdata_form_frame">
            <div className="masterdata_form">
              {store.type === "raw" && (
                <div className="formfield">
                  <div className="formfield_label">
                    Mérlegjegy
                    {qualities.Quality.WeighBill === "error" && (
                      <div className="formfield_label-error">
                        (eltérő mérlegjegyek)
                      </div>
                    )}
                  </div>
                  <div className="formfield_input">
                    <input
                      className="edit-input"
                      value={
                        qualities.Quality.WeighBill !== "error"
                          ? qualities.Quality.WeighBill
                          : null
                      }
                      onChange={(e) =>
                        store.setInput("WeighBill", e.target.value)
                      }
                    />
                  </div>
                </div>
              )}

              {store.type === "raw" && (
                <div className="formfield">
                  <div className="formfield_label">
                    Súly
                    {qualities.Quality.WeighBillQuantity === "error" && (
                      <div className="formfield_label-error">
                        (eltérő mérlegjegyek)
                      </div>
                    )}
                  </div>
                  <div className="formfield_input">
                    <input
                      className="edit-input"
                      value={
                        qualities.Quality.WeighBillQuantity !== "error"
                          ? qualities.Quality.WeighBillQuantity
                          : null
                      }
                      onChange={(e) =>
                        store.setInput("WeighBillQuantity", e.target.value)
                      }
                    />
                  </div>
                </div>
              )}

              {store.type === "processed" && (
                <div className="formfield">
                  <div className="formfield_label">
                    Labor sorszám
                    {qualities.Quality.LabId === "error" && (
                      <div className="formfield_label-error">
                        (eltérő labor sorszámok)
                      </div>
                    )}
                  </div>
                  <div className="formfield_input">
                    <input
                      className="edit-input"
                      value={
                        qualities.Quality.LabId !== "error"
                          ? qualities.Quality.LabId
                          : null
                      }
                      onChange={(e) => store.setInput("LabId", e.target.value)}
                    />
                  </div>
                </div>
              )}

              <div className="formfield">
                <div className="formfield_label">Faj / fajta</div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {qualities.ItemName}
                  </span>
                </div>
              </div>

              {qualities.CustomItem && (
                <div className="formfield">
                  <div className="formfield_label">Megjegyzés</div>
                  <div className="formfield_input">
                    <span className="formfield_input-label">
                      {qualities.CustomItem}
                    </span>
                  </div>
                </div>
              )}

              <div className="formfield">
                <div className="formfield_label">
                  Beszállító
                  {qualities.Supplier === "error" && (
                    <div className="formfield_label-error">(eltérő adatok)</div>
                  )}
                </div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {qualities.SupplierName}
                  </span>
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">
                  Gép
                  {qualities.Machine === "error" && (
                    <div className="formfield_label-error">(eltérő adatok)</div>
                  )}
                </div>
                <div className="formfield_input">
                  <span className="formfield_input-label">
                    {qualities.MachineName}
                  </span>
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">
                  Tisztítás sorszáma
                  {qualities.CleaningCount === "error" && (
                    <div className="formfield_label-error">(eltérő adatok)</div>
                  )}
                </div>
                <div className="formfield_input">
                  {qualities && (
                    <span className="formfield_input-label">
                      {qualities.CleaningCount !== "error"
                        ? qualities.CleaningCount
                        : ""}
                    </span>
                  )}
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">
                  Tisztítási fok
                  {qualities.CleaningRate === "error" && (
                    <div className="formfield_label-error">(eltérő adatok)</div>
                  )}
                </div>
                <div className="formfield_input">
                  {qualities && (
                    <span className="formfield_input-label">
                      {qualities.CleaningRateName}
                    </span>
                  )}
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">Azonosítók</div>
                <div className="formfield_input">
                  {qualities && (
                    <span className="formfield_input-label">
                      {qualities.LotNos.join(", ")}
                    </span>
                  )}
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">
                  Felhasználó
                  {qualities.User === "error" && (
                    <div className="formfield_label-error">
                      (eltérő felhasználók)
                    </div>
                  )}
                </div>
                <div className="formfield_input">
                  {qualities && (
                    <span className="formfield_input-label">
                      {qualities.User !== "error" ? qualities.UserName : ""}
                    </span>
                  )}
                </div>
              </div>

              <div className="formfield">
                <div className="formfield_label">
                  Időpont
                  {qualities.Timestamp === "error" && (
                    <div className="formfield_label-error">
                      (eltérő időpontok)
                    </div>
                  )}
                </div>
                <div className="formfield_input">
                  {qualities && (
                    <span className="formfield_input-label">
                      {qualities.Timestamp !== "error"
                        ? qualities.Timestamp
                        : ""}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="masterdata_form wrapped">
              {store.qualitytypes.map((qualitytype) => {
                console.log(store.type, qualitytype);
                if (qualitytype.hidden || qualitytype[store.type] === false)
                  return null;
                return (
                  <div key={qualitytype.name} className="formfield wrapped">
                    <div className="formfield_label">
                      {qualitytype.text}
                      {qualities.Quality[qualitytype.name] === "error" && (
                        <div className="formfield_label-error">
                          (eltérő adatok)
                        </div>
                      )}
                    </div>
                    <div className="formfield_input">
                      <input
                        className="edit-input"
                        value={
                          qualities.Quality[qualitytype.name] !== "error"
                            ? qualitytype.type === "double" &&
                              qualities.Quality[qualitytype.name]
                              ? qualities.Quality[qualitytype.name]
                                  .toString()
                                  .replace(".", ",")
                              : qualities.Quality[qualitytype.name]
                            : null
                        }
                        onChange={(e) =>
                          store.setInput([qualitytype.name], e.target.value)
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {(this.state.popup === "error" || this.state.popup === "result") && (
          <Popup
            key="popup"
            text={this.state.popupText}
            buttons={[
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                  if (this.state.popup === "error") this.back();
                }}
              >
                Ok
              </Button>,
            ]}
            onClickClose={() => {
              this.setState({ popup: "none" });
              if (this.state.popup === "error") this.back();
            }}
          />
        )}
        {this.state.popup === "delete" && (
          <Popup
            key="popup"
            text="Biztosan törli?"
            buttons={[
              <Button
                className="popup_button"
                onClick={() => {
                  this.setState({ popup: "none" });
                  this.delete();
                }}
              >
                Igen
              </Button>,
              <Button
                className="popup_button"
                onClick={(e) => {
                  this.setState({ popup: "none" });
                }}
              >
                Mégse
              </Button>,
            ]}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_QUALITIES_DETAILS}>
    {(routeProps) => <QualitiesDetails {...routeProps} {...props} />}
  </RouteNode>
);
